import { Box, FormHelperText, Link, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import type { AddressSearchListType } from './AddressSearchList';

export type AddressSearchHelperTypes = {
  showResults: boolean;
  onManualSelect: AddressSearchListType['onManualSelect'];
};

export const AddressSearchHelper: React.FC<AddressSearchHelperTypes> = ({ showResults, onManualSelect }) => {
  const { classes } = useStyles();

  if (showResults) {
    const link = (
      <Link
        component="button"
        variant="body2"
        underline="always"
        className={classes.link}
        onClick={onManualSelect}
      >Enter it manually.</Link>
    );

    return (
      <Box p={2}>
        <Typography variant="body2" component="span">
          Don&apos;t see your address? {link}
        </Typography>
      </Box>
    );
  } else {
    return (
      <Box mt={2}>
        <FormHelperText>
          Start typing your address and then select it from the list
        </FormHelperText>
      </Box>
    );
  }
};

const useStyles = makeStyles()({
  link: {
    fontFamily: 'inherit',
    verticalAlign: 'baseline'
  }
});
